import '../fonts/Buckskin.otf';
import '../fonts/commuters-sans-heavy.otf';
import '../fonts/TT-Cottons-Black.otf';
import '../fonts/AktivGrotesk_Rg.ttf';

import '../images/heros/jfk.jpg';
import '../images/heros/paul-newman.jpg';
import '../images/heros/michael-bastian.jpg';
import '../images/heros/bjorn-borg.jpg';
import '../images/heros/sly-Stallone.jpg';
import '../images/heros/virgil-abloh.jpg';
import '../images/heros/john-mayer.jpg';
import '../images/heros/luka-sabbat.jpg';
import '../images/heros/zayn-malik.jpg';
import '../images/heros/lebron-james.jpg';
import '../images/heros/jonah-hill.jpg';
import '../images/heros/aziz-ansari.jpg';

import '../images/heros/ronnie-feig.png';
import '../images/heros/tatsuya-nakamura.png';
import '../images/heros/nick-wooster.png';
import '../images/heros/todd-snyder.jpg';


import '../images/products/sneakerhead/47_Mechanics Jacket.png';
import '../images/products/sneakerhead/48_Denim Garage Jacket.png';
import '../images/products/sneakerhead/49_Vintage Wash Bomber Jacket.png';
import '../images/products/sneakerhead/50_Chanel Hooded Sweatshirt.png';
import '../images/products/sneakerhead/51_Uneven Dye Crew Socks.png';
import '../images/products/sneakerhead/52_Oversized Pocket Tee.png';
import '../images/products/sneakerhead/53_I Fee Like Pablo Hat.png';
import '../images/products/sneakerhead/54_Diagonal Market Arrows Sweatpant.png';
import '../images/products/sneakerhead/55_Candle Tee.png';
import '../images/products/sneakerhead/56_Season 6 Classic Hoody.png';
import '../images/products/sneakerhead/57_Three Stripe Sock.png';
import '../images/products/sneakerhead/58_Fisatto Tee.png';
import '../images/products/sneakerhead/59_Patch Cap.png';
import '../images/products/sneakerhead/60_Striped Polo Shirt.png';
import '../images/products/sneakerhead/61_Ebisu Track Sweats.png';
import '../images/products/sneakerhead/62_Swayze T-Shirt.png';
import '../images/products/sneakerhead/63_ALD Logo Hat.png';
import '../images/products/sneakerhead/64_Grey Denim Rivingtons Jean.png';
import '../images/products/sneakerhead/65_Zip Pocket Sweatpant.png';
import '../images/products/sneakerhead/66_Utica Tee.png';
import '../images/products/sneakerhead/67_62265 Hand Brush Color Treatment Hooded Sweatshirt.png';
import '../images/products/sneakerhead/68_UCU4801 Sleeveless Sweater.png';
import '../images/products/sneakerhead/69_Cut-Off Sweatshort.png';

import '../images/products/active/10_Reverse Weave Jogger Pants.png';
import '../images/products/active/11_Wings Lite Knit Sweat Shorts.png';
import '../images/products/active/12_Essentials Cotton Polo.png';
import '../images/products/active/13_Summer Rebel Logo Tee.png';
import '../images/products/active/14_Heritage Tank, Collegiate Crest.png';
import '../images/products/active/15_Seersucker Performance Golf Short.png';
import '../images/products/active/16_Rush short.png';
import '../images/products/active/17_Thermal Cotton Full Zip Hoodie.png';
import '../images/products/active/18_Cotton Relax Cap.png';
import '../images/products/active/19_Tri-Block Ankle Sock.png';
import '../images/products/active/20_Dwarf Duffel.png';
import '../images/products/active/21_Striped Slim Sweatpant in Salt and Pepper.png';
import '../images/products/active/22_Drop Shoulder Hoodie- Sandstone.png';
import '../images/products/active/3_Flip Vector Hoodie.png';
import '../images/products/active/4_Sportswear Shorts.png';
import '../images/products/active/5_Jumpman Air Tank.png';
import '../images/products/active/6_ID Satdium Shorts.png';
import '../images/products/active/7_Mercerized Cotton Polo.png';
import '../images/products/active/8_Heritage 86 Hat.png';
import '../images/products/active/9_Guru Muscle Tank.png';

import '../images/products/allAmerican/70_Max Used Black Jeans.png';
import '../images/products/allAmerican/71_Shadow Stripe T-Shirt.png';
import '../images/products/allAmerican/72_Marled Indigo Knit Blazer.png';
import '../images/products/allAmerican/73_Oil Cloth Bomber.png';
import '../images/products/allAmerican/74_MA-1 Cotton Bomber.png';
import '../images/products/allAmerican/75_Painter Pant.png';
import '../images/products/allAmerican/76_Slub Crewneck Pocket T-shirt.png';
import '../images/products/allAmerican/77_Olive Slim Twill Suit Jacket.png';
import '../images/products/allAmerican/78_Straight Fit Jeans.png';
import '../images/products/allAmerican/79_Denim Houstons.png';
import '../images/products/allAmerican/80_Stonewash Trucker Jacket.png';
import '../images/products/allAmerican/81_Mason Navy Tapered Chino.png';
import '../images/products/allAmerican/82_Knitted Polka Dot Tie.png';
import '../images/products/allAmerican/83_Nash Cotton T-Shirt.png';
import '../images/products/allAmerican/84_Classic Pocket Sweatshirt.png';
import '../images/products/allAmerican/85_Color Khakis.png';
import '../images/products/allAmerican/86_Classic Corduroy Shorts.png';
import '../images/products/allAmerican/87_Camaiore Backpack.png';
import '../images/products/allAmerican/88_Seersucker Short Sleeve Camp Collar Shirt.png';
import '../images/products/allAmerican/89_2297 Mariniere Heritage Tee.png';
import '../images/products/allAmerican/90_Open Paisley Pocket Square.png';
import '../images/products/allAmerican/91_Stretch Cotton Sport Coat.png';
import '../images/products/allAmerican/92_Monaco Hat.png';
import '../images/products/allAmerican/93_Short Sleeve Murphy Shirt.png';
import '../images/products/allAmerican/94_Chambray Classics.png';
import '../images/products/allAmerican/95_Summer Weight Shorts.png';

import '../images/products/prep/23_1984 Striped Cotton-Jersey Polo.png';
import '../images/products/prep/24_Aiden Slim Rapid Movement Chino.png';
import '../images/products/prep/25_Vintage Two Pocket Shirt.png';
import '../images/products/prep/26_Classic Stretch Blazer.png';
import '../images/products/prep/27_Cotton-Twill Polo Shirt.png';
import "../images/products/prep/28_Levi's Made In USA 511.png";
import '../images/products/prep/29_Appliqued Cotton-Twill Cap.png';
import '../images/products/prep/30_Classic Polo Shirt.png';
import '../images/products/prep/31_Cotton Stripe Polo.png';
import '../images/products/prep/32_Swordfish Print Socks.png';
import '../images/products/prep/33_Striped Cotton Sweater.png';
import '../images/products/prep/34_Boucle-Striped T-Shirt.png';
import '../images/products/prep/35_Survivor Shorts.png';
import '../images/products/prep/36_Cotton Pique Blazer.png';
import '../images/products/prep/37_Classic Seersucker Short Sleeved Shirt.png';
import '../images/products/prep/38_Air Oxford Shirt .png';
import '../images/products/prep/39_U Harrington Jacket.png';
import '../images/products/prep/40_Slim Fit Cotton Twill Chinos.png';
import '../images/products/prep/41_Striped Jersey Tee.png';
import '../images/products/prep/42_Cotton Printed Bow Tie.png';
import '../images/products/prep/43_Traveler Mock Neck Cotton Sweater.png';
import '../images/products/prep/44_Cotton Cashmere Silk Sweater.png';
import '../images/products/prep/45_Athletic Slim Cargo Pants.png';
import '../images/products/prep/46_Dellow Canvas Sneakers.png';

import '../images/products/trendsetter/100_Olive Seersucker Shirt Jacket.png';
import '../images/products/trendsetter/101_Otis Straight Crop Jeans.png';
import '../images/products/trendsetter/102_M Bucket Hat.png';
import '../images/products/trendsetter/103_Peek-a-Boo Low Tops.png';
import '../images/products/trendsetter/104_Garment-Dyed Cotton-Twill Jacket.png';
import '../images/products/trendsetter/105_Round Neck Striped Jumper.png';
import '../images/products/trendsetter/106_Logo T-Shirt.png';
import '../images/products/trendsetter/107_Reverse Weave Tie Dye Shirt.png';
import '../images/products/trendsetter/108_Black Cargo Pants.png';
import '../images/products/trendsetter/109_Surf Is Love T-Shirt.png';
import '../images/products/trendsetter/110_Appliqued and Printed Denim Jacket.png';
import '../images/products/trendsetter/111_Newcomb Michigan Coat.png';
import '../images/products/trendsetter/112_Graffiti Hoodie.png';
import '../images/products/trendsetter/113_Baker Slim-Fit Camouflage- Print Cotton Shorts.png';
import '../images/products/trendsetter/114_Off-Whtie Canvas Emoji High-Top Sneakers.png';
import '../images/products/trendsetter/115_Leopard Crewneck Sweater.png';
import '../images/products/trendsetter/116_Jasper Emroidered Jeans.png';
import '../images/products/trendsetter/117_Grandad Collar Shirt.png';
import '../images/products/trendsetter/118_Blue Joy Division Substance Side Closure Shirt.png';
import '../images/products/trendsetter/119_Beams Plus Army Hat.png';
import '../images/products/trendsetter/120_Military Coat.png';
import '../images/products/trendsetter/121_Baseball Hat.png';
import '../images/products/trendsetter/96_Townsend Jacket.png';
import '../images/products/trendsetter/97_Short Sleeve V-Neck.png';
import '../images/products/trendsetter/98_Distressed Wight Jean.png';
import '../images/products/trendsetter/99_Baldwin Henley Slim Straight Sand.png';

import '../images/backarrow.png';
import '../images/carousel-cursor.png';
import '../images/carousel-cursor-back.png';


/*******************************************************************************************/
/********************************** ANIMATION IMPORTS **************************************/
/*******************************************************************************************/
import '../images/animations/sneakerhead/img_0.png';
import '../images/animations/sneakerhead/img_1.png';
import '../images/animations/sneakerhead/img_2.png';
import '../images/animations/sneakerhead/img_3.png';
import '../images/animations/sneakerhead/img_4.png';

import '../images/animations/allAmerican/img_0.png';
import '../images/animations/allAmerican/img_1.png';
import '../images/animations/allAmerican/img_2.png';
import '../images/animations/allAmerican/img_3.png';
import '../images/animations/allAmerican/img_4.png';
import '../images/animations/allAmerican/img_5.png';

import '../images/animations/prep/img_0.png';
import '../images/animations/prep/img_1.png';
import '../images/animations/prep/img_2.png';
import '../images/animations/prep/img_3.png';
import '../images/animations/prep/img_4.png';

import '../images/animations/active/img_0.png';
import '../images/animations/active/img_1.png';
import '../images/animations/active/img_2.png';

import '../images/animations/trendsetter/img_0.png';
import '../images/animations/trendsetter/img_1.png';
import '../images/animations/trendsetter/img_2.png';

import '../images/animations/bg-transitions/1/img_0.png';
import '../images/animations/bg-transitions/1/img_1.png';
import '../images/animations/bg-transitions/2/img_0.png';
import '../images/animations/bg-transitions/2/img_1.png';
import '../images/animations/bg-transitions/3/img_0.png';
import '../images/animations/bg-transitions/3/img_1.png';
import '../images/animations/bg-transitions/4/img_0.png';
import '../images/animations/bg-transitions/4/img_1.png';

import '../images/urban-star.png';


import Pre from 'pre-js';

Pre()
.asset('/src/fonts/Buckskin.otf')
.asset('/src/fonts/commuters-sans-heavy.otf')
.asset('/src/fonts/TT-Cottons-Black.otf')
.asset('/src/fonts/AktivGrotesk_Rg.ttf')

.asset('/src/images/animations/sneakerhead/img_0.png')
.asset('/src/images/animations/sneakerhead/img_1.png')
.asset('/src/images/animations/sneakerhead/img_2.png')
.asset('/src/images/animations/sneakerhead/img_3.png')
.asset('/src/images/animations/sneakerhead/img_4.png')

.asset('/src/images/animations/allAmerican/img_0.png')
.asset('/src/images/animations/allAmerican/img_1.png')
.asset('/src/images/animations/allAmerican/img_2.png')
.asset('/src/images/animations/allAmerican/img_3.png')
.asset('/src/images/animations/allAmerican/img_4.png')
.asset('/src/images/animations/allAmerican/img_5.png')

.asset('/src/images/animations/prep/img_0.png')
.asset('/src/images/animations/prep/img_1.png')
.asset('/src/images/animations/prep/img_2.png')
.asset('/src/images/animations/prep/img_3.png')
.asset('/src/images/animations/prep/img_4.png')

.asset('/src/images/animations/active/img_0.png')
.asset('/src/images/animations/active/img_1.png')
.asset('/src/images/animations/active/img_2.png')

.asset('/src/images/animations/trendsetter/img_0.png')
.asset('/src/images/animations/trendsetter/img_1.png')
.asset('/src/images/animations/trendsetter/img_2.png')

.asset('/src/images/animations/bg-transitions/1/img_0.png')
.asset('/src/images/animations/bg-transitions/1/img_1.png')
.asset('/src/images/animations/bg-transitions/2/img_0.png')
.asset('/src/images/animations/bg-transitions/2/img_1.png')
.asset('/src/images/animations/bg-transitions/3/img_0.png')
.asset('/src/images/animations/bg-transitions/3/img_1.png')
.asset('/src/images/animations/bg-transitions/4/img_0.png')
.asset('/src/images/animations/bg-transitions/4/img_1.png')

.on('progress', function(e) {
  //console.log(e.completed, e.total);
   if (e.completed === e.total) {
    var event = new Event('preload-done');
    document.dispatchEvent(event);
   }
 });
